<template>
  <span 
    :class="classList"
    class="Tag"
    @click="toggle">
    <span v-if="hasValidType">
      <font-awesome-icon class="pin" :icon="['fal', 'map-marker-alt']" /> 
    </span>
    {{ label }}
  </span>
</template>

<script>
export default {
  name: 'Tag',
  props: {
    label: {
      type: String,
      required: true
    },
    slug: {
      type: String,
      required: true
    },
    compact: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'thema'
    }
  },
  computed: {
    classList() {
      let list = {
        'Tag--compact' : this.compact,
        'Tag--labeled' : this.hasValidType && ! this.compact,
        'Tag--active'  : this.active
      }
      list[`Tag--${this.type.toLowerCase()}`] = this.hasValidType && ! this.compact;
      return list;
    },
    hasValidType() {
      return [
        'thema', 'bouw', 'kennis', 'leverancier', 'gemeente', 'corporatie'
      ].includes(this.type.toLowerCase());
    },
    active() {
      let filters = this.$store.getters.getFilters;
      return filters === `${this.type.toLowerCase()}--${this.slug}`;
    }
  },
  methods: {
    toggle() {

      if (!this.active) {
        let project = this.$store.getters.getActiveProject;
        
        if (project) {
          let filter = ['all', ['==', 'slug', this.slug], ['has', project.id]]; // , ['==', 'type', 'thema']
          // TODO: combined filters is possible with line below, needs proper visual
          // filter = ['all', filter, filter]; 
          this.$store.map.setFilter('connections', filter)
          this.$store.dispatch('setFilters', {
            filters: `${this.type.toLowerCase()}--${this.slug}`
          });

          if (this.type === 'thema') {
            let thema = this.$store.getters.getThemaBySlug({ slug: this.slug });
            // Zoom...
            this.$store.dispatch('setHighlightedProjectList', {
              projects: this.$store.getters.getProjectIdsByThema({id: thema.id})
            });
          } else {
            let partij = this.$store.getters.getPartijBySlug({ slug: this.slug });
            // Zoom...
            this.$store.dispatch('setHighlightedProjectList', {
              projects: this.$store.getters.getProjectIdsByPartij({id: partij.id})
            });
          }
        }
      } else {
        this.$store.map.setFilter('connections', ['==', 'type', 'off'])
        this.$store.dispatch('setFilters', {
          filters: `off`
        });
      }
    }
  }
}
</script>

<style lang="scss">
  .Tag {
    position: relative;
    background: $gray_mid;
    color: black;
    padding: 12px 16px;
    border-radius: 4px;
    font-family: $font_nav;
    font-size: 16px;
    margin-right: 16px;
    // cursor: not-allowed;
    cursor: pointer;
    margin-bottom: 8px;
    user-select: none;


    &--labeled {
      padding-left: 48px;
      
      span {
        position: absolute;
        display: flex;
        width: 32px;
        height: 100%;
        top: 0;
        left: 0;
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
        justify-content: center;
        align-items: center;
      }
    }

    &--thema {
      background: lighten($metro_oranje, 45%);

      &:hover, span {
        background: $metro_oranje;
      }
    }
    &--active.Tag--thema {
      background: $metro_oranje;
    }
    
    &--bouw {
      background: lighten($metro_geel, 35%);

      &:hover, span {
        background: $metro_geel;
      }
    }
    &--active.Tag--bouw {
      background: $metro_geel;
    }

    &--kennis {
      background: lighten($metro_blauw, 50%);

      &:hover, span {
        background: $metro_blauw;
      }
    }
    &--active.Tag--kennis {
      background: $metro_blauw;
    }

    &--leverancier {
      background: lighten($metro_groen, 55%);

      &:hover, span {
        background: $metro_groen;
      }
    }
    &--active.Tag--leverancier {
      background: $metro_groen;
    }

    &--gemeente {
      background: lighten($metro_rood, 45%);

      &:hover, span {
        background: $metro_rood;
      }
    }
    &--active.Tag--gemeente {
      background: $metro_rood;
    }

    &--corporatie {
      background: lighten($metro_paars, 40%);

      &:hover, span {
        background: $metro_paars;
      }
    }
    &--active.Tag--corporatie {
      background: $metro_paars;
    }

    &--compact {
      margin: 0;
      padding: 0;
      background: transparent;
      display: inline;
      cursor: default;
 
      span {
        display: none;
      }
    }
  }
</style>
